module.exports = __webpack_public_path__ + "static/media/ambassador-benefits.410cc8ae.jpg";